import { render, staticRenderFns } from "./UpdateStockDrawer.vue?vue&type=template&id=1e60f240&scoped=true&lang=pug&"
import script from "./UpdateStockDrawer.vue?vue&type=script&lang=js&"
export * from "./UpdateStockDrawer.vue?vue&type=script&lang=js&"
import style0 from "./UpdateStockDrawer.vue?vue&type=style&index=0&id=1e60f240&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e60f240",
  null
  
)

/* custom blocks */
import block0 from "./UpdateStockDrawer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports